<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-top-transition"
    max-width="600"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon color="botao_1" class="mr-1" v-bind="attrs" v-on="on" dark small
        >mdi-delete</v-icon
      >
    </template>

    <v-card class="rounded-lg">
      <v-toolbar dark class="rounded-lg" color="primary">
        Remover::{{ id }}
      </v-toolbar>

      <br />

      <v-card-text>
        <h1>Tem certeza que deseja remover?</h1>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn text @click="dialog = false"> Cancelar </v-btn>
        <v-btn text @click="remover()"> Remover </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/services/api";
import verifica_token_storage from "@/utils/verifica_token_storage";
import { mapMutations } from "vuex";

export default {
  name: "RemoverUsuario",

  props: {
    id: Number,
  },

  data: () => ({
    dialog: false,
    form: {},
  }),

  methods: {
    ...mapMutations(["CarregandoMutation"]),

    remover() {
      this.CarregandoMutation();
      const headers = verifica_token_storage();

      api
        .delete(`admin/usuarios/${this.id}`, { headers })
        .then(() => {
          this.$emit("form-submit", this.id);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          // Resetar
          this.dialog = false;
          this.form = {};
          this.CarregandoMutation();
        });
    },
  },
};
</script>
